import { HeaderAndTableCellDraft, SortAttributes } from '@markant-platform/shared/table/model';
import { CartridgeOverviewInfo } from '@markant-platform/shared/organization/model';

export const TABLE_HEADER_AND_CELLS: HeaderAndTableCellDraft[] = [
  {
    headerCellColumnId: 'name',
    headerCellTranslationKey: 'dashboard.cartridge.overviewTable.col.name',
    tableCellContentType: 'CHIP_AND_STRING',
    tableCellContentKey: 'name',
    additionalChip: {
      displayCondition: (obj: unknown): boolean => {
        return !!(obj as CartridgeOverviewInfo).showNotUiBookableChip;
      },
      tableCellContentKey: 'showNotUiBookableChip',
      tableCellTranslationPrefix: 'catalog.notUiBookable',
      chipConfigMap: {
        TRUE: { color: 'warning', icon: '' },
      },
    },
  },
];

export const DEFAULT_SORT: SortAttributes = { sortField: 'name', sortOrder: 'asc' };
